import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// material-ui
import { Box, Grid, Typography, makeStyles } from "@material-ui/core";

// components
import InputBox from "@/components/shared/InputBox";
import SelectBox from "@/components/shared/SelectBox";
import Button from "@/components/shared/Button";

// props
import getLoginPageProps from "@/props-constants/login-props";

const useStyles = makeStyles((theme) => ({
	pageContainer: {
		marginTop: theme.spacing(20),
		textAlign: "center",
	},
	buttonContainer: {
		marginTop: theme.spacing(2),
	},
	cInputBoxContainer: {
		width: "100%",
		margin: theme.spacing(1.5, 0),
	},
	cInputBoxLabel: {
		color: theme.palette.common.black,
		fontSize: theme.spacing(2.25),
	},
}));

export default function Login() {
	const classes = useStyles();
	const dispatch = useDispatch();

	const loginProps = getLoginPageProps(dispatch);
	// states
	const [universityCode, setUniversityCode] = useState("");
	const [eventID, setEventID] = useState("");

	const location = useSelector((state) => state.router.location);

	useEffect(() => {
		// URLSearchParams turns "+" into space; university codes can contain "+".
		const getQueryParam = (key) => {
			const match = String(location.search || "").match(
				new RegExp(`[?&]${key}=([^&]*)`)
			);
			if (!match) return "";
			return decodeURIComponent(match[1].replace(/\+/g, "%2B")).trim();
		};
		const fairId = getQueryParam("fair_id");
		const universityCodeFromUrl = getQueryParam("university_code");
		if (universityCodeFromUrl && fairId) {
			const payload = {
				fair_id: fairId,
				university_code: universityCodeFromUrl,
			};
			loginProps.loginWithURL(payload);
			setEventID(fairId);
			setUniversityCode(universityCodeFromUrl);
		}
	}, [location]);

	const handleLogin = () => {
		const payload = {
			university_code: universityCode.trim(),
			fair_id: eventID.trim(),
		};
		loginProps.loginButton.onClick(payload);
	};

	const handleUniveristyInputBoxOnChange = (event) => {
		setUniversityCode(event.target.value);
	};
	const handleEventTypeBoxOnChange = (event) => {
		setEventID(event.target.value);
	};

	return (
		<Box className={classes.pageContainer}>
			<Box p={1} my={10}>
				<Box>
					<Typography color="primary" variant="h1">
						{loginProps.heading.title}
					</Typography>
				</Box>
				<Box mt={2}>
					<Typography variant="h4">{loginProps.heading.subTitle}</Typography>
				</Box>
			</Box>
			<Grid container justifyContent="center">
				<Grid item md={4} xs={10}>
					<InputBox
						{...loginProps.inputFields.inputBox}
						classes={{
							cInputBoxContainer: classes.cInputBoxContainer,
							cInputLabel: classes.cInputBoxLabel,
						}}
						onChange={handleUniveristyInputBoxOnChange}
						defaultValue={universityCode}
					/>
				</Grid>
			</Grid>
			<Grid container justifyContent="center">
				<Grid item md={4} xs={10}>
					<SelectBox
						{...loginProps.inputFields.selectBox}
						classes={{
							cSelectBoxContainer: classes.cInputBoxContainer,
							cSelectBoxLabel: classes.cInputBoxLabel,
						}}
						onChange={handleEventTypeBoxOnChange}
						defaultValue={eventID}
					/>
				</Grid>
			</Grid>
			<Grid className={classes.buttonContainer} container justifyContent="center">
				<Grid item md={4} xs={10}>
					<Button {...loginProps.loginButton} onClick={handleLogin} />
				</Grid>
			</Grid>
		</Box>
	);
}
